import { entitySymbols, withMetadata } from '@pf/shared-utility';
import { IMappingProfile, PFLoadEntities } from '@pf/shared-common';
import { StopStatusFragment } from '@control-tower/platform-loads/model/stopStatusFragment';
import { ITypeEntityFragmentSymbol } from '@pf/shared/util-platform';
import { StopStatusViewModel } from '@control-tower/platform-loads/model/stopStatusViewModel';
import { createMap, forMember, mapFrom, Mapper } from '@automapper/core';

export type StopStatusRead = StopStatusFragment;
export type StopStatusCreate = StopStatusViewModel;

const symbols = entitySymbols(PFLoadEntities.Stop + 'Status');
symbols.dto = symbols.entity;

withMetadata<StopStatusRead>(symbols.entity, {
    stopStatusType: ITypeEntityFragmentSymbol,
    lastUpdated: String,
});
withMetadata<StopStatusCreate>(symbols.createBody, {
    stopStatusTypeId: String,
    lastUpdated: String,
});

export const StopStatusMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<StopStatusRead, StopStatusCreate>(
            mapper,
            symbols.dto,
            symbols.createBody,
            forMember(
                x => x.stopStatusTypeId,
                mapFrom(source => source.stopStatusType?.id || null)
            )
        );
    },
};
